import { UPDATE_TRANSLATION_SUCCESS, UPDATE_TRANSLATION_FAILURE,  GET_TRANSLATION_SUCCESS } from "../actions/translationActions";

const initialState={
    loading: true,
    data: [],
    error : ""
}

const TRANSLATION = (state=initialState, action)=> { 
    switch(action.type){
        case GET_TRANSLATION_SUCCESS:
            return {
                loading:false,
                data: action.payload,
                error:null
            }
        case UPDATE_TRANSLATION_SUCCESS:
            return {
                loading:false,
                data: action.payload,
                error:null
            }
        case UPDATE_TRANSLATION_FAILURE: 
            return{
                loading:false,
                data: [],
                error: action.payload
            }
        default: return state;
    }
}

export default TRANSLATION;